import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {ListGroupItem, ListGroup} from 'react-bootstrap'
import {Link} from 'react-router'
import CompactListItem from '../components/CompactListItem'
import {listModes} from './IdeaList'
// import { majorModes } from './Header'

class CompactList extends Component {

//CompactList
    render() {

        let viewMode = this.props.viewMode
        
        // console.log('filteredIdeasToShow', this.props.filteredIdeasToShow.length)
        // console.log('loadingOwnIdeas', this.props.loadingOwnIdeas)

        return (
            <ListGroup fill>
                {this.props.filteredIdeasToShow.map((idea) =>
                    <ListGroupItem key={idea.key} className='filteredListItem'>
                        <Link style={{textDecoration: 'none'}} className='filteredLinkItem' to={{ pathname: '/idea/'+ idea.key +'/view' }}>
                            {viewMode === listModes.compact &&
                                <CompactListItem item={idea} showFields={this.props.compactPref}/>
                            }
                        </Link>
                    </ListGroupItem>,
                )}
            </ListGroup>
        )
    }
}

CompactListItem.propTypes = {
    filteredIdeasToShow: PropTypes.object,
    compactPref: PropTypes.string,
    loadingOwnIdeas : PropTypes.bool,
    ideaGroup: PropTypes.string,
    viewMode: PropTypes.number,
}

export default CompactList



// WEBPACK FOOTER //
// ./src/containers/CompactList.js